import { ComponentFactoryResolver, Injectable, Type } from '@angular/core';
import { ModalBaseComponent } from '../components/modal-base/modal-base.component';
import { IModalComponent } from '../types/modal/modal-base';
import { ModalButton } from '../types/modal/modal-button';

@Injectable()
export class AppModalService {

  public title: string;
  private componentInstance: IModalComponent = null;
  private baseComponent: ModalBaseComponent = null;

  constructor(
      private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  setBaseComponent(component: ModalBaseComponent) {
    this.baseComponent = component;
  }

  /**
   * Opens component as modal
   *
   * @param modalContentComponent
   * @param data
   * @param title
   */
  public open<T>(modalContentComponent: Type<T & IModalComponent>, data?: any, title?: string): T {
    if(!this.baseComponent) {
      throw new ReferenceError('Modal base component is not defined');
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(modalContentComponent);
    this.baseComponent.appModalHost.viewContainerRef.clear();
    this.componentInstance = this.baseComponent.appModalHost.viewContainerRef.createComponent(componentFactory).instance as IModalComponent;

    this.componentInstance.baseComponent = this.baseComponent;

    if(data) {
      this.componentInstance.data = data;
    }

    this.baseComponent.title = title || this.componentInstance.title;
    this.baseComponent.buttons = this.componentInstance.buttons;

    this.baseComponent.open();

    return this.componentInstance as any;
  }

  /**
   * Returns modal buttons list
   */
  get modalButtons(): ModalButton[] {
    return this.componentInstance && this.componentInstance.buttons ? this.componentInstance.buttons : [];
  }

  /**
   * Closes modal
   */
  public close() {
    this.baseComponent.close();
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/app-modal.service.ts